import * as PlasmicQuery from "@plasmicapp/query";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as jsxDevRuntime from "react/jsx-dev-runtime";
import * as jsxRuntime from "react/jsx-runtime";
import { registerRenderErrorListener, setPlasmicRootNode } from "./canvas-host";
import * as hostModule from "./exports";
import { setRepeatedElementFn } from "./repeatedElement";
// version.ts is automatically generated by `yarn build` and not committed.
import { hostVersion } from "./version";

// All exports must come from "./exports"
export * from "./exports";

const root = globalThis as any;

if (root.__Sub == null) {
  // Creating a side effect here by logging, so that vite won't
  // ignore this block for whatever reason. Hiding this for now
  // as users are complaining; will have to check if this has
  // been fixed with vite.
  // console.log("Plasmic: Setting up app host dependencies");
  root.__Sub = {
    React,
    ReactDOM,
    jsxRuntime,
    jsxDevRuntime,
    PlasmicQuery,
    hostModule,
    hostVersion,
    hostUtils: {
      setPlasmicRootNode,
      registerRenderErrorListener,
      setRepeatedElementFn,
    },

    // For backwards compatibility:
    setPlasmicRootNode,
    registerRenderErrorListener,
    setRepeatedElementFn,
    ...hostModule,
  };
} else {
  console.warn(
    `Encountered likely duplicate host version: ${root.__Sub.hostVersion} vs ${hostVersion}`
  );
  root.__Sub.duplicateHostVersions = root.__Sub.duplicateHostVersions ?? [];
  root.__Sub.duplicateHostVersions.push(hostVersion);
}
